import * as ileggelserActions from "../actions/ileggelserActions";

const INITIAL_STATE = [];

export default function ileggelseKlagebehandlingVedtakReducer(
  state = [...INITIAL_STATE],
  action,
) {
  switch (action.type) {
    case ileggelserActions.GET_ILEGGELSER_KLAGEBEHANDLING_VEDTAK_SUCCESS:
      return [...action.payload];
    default:
      return state;
  }
}
